module.exports = __webpack_public_path__ + "static/media/outer_11.df7b17d5.jpg";